import $ from 'jquery'

$('.js-open-modal-ride').on('click', function (e) {
    e.preventDefault();
})
